
/* Accueil · Shakes & cookies : les tirages se collent quand la section arrive à l'écran, une fois les photos prêtes.
   Au repos, sans script ou en mouvement réduit, tout est en place ; si la section est déjà visible au chargement, rien ne se rejoue.
   Les photos se chargent un écran avant ; si elles ne sont pas prêtes à temps (connexion lente), elles s'affichent sans effet. */
(function(){
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  [].forEach.call(document.querySelectorAll('[data-pb]'), function(pb){
    if (pb.getBoundingClientRect().top < window.innerHeight) return;
    var imgs = [].slice.call(pb.querySelectorAll('img')), done = false;
    function ready(){ return imgs.every(function(i){ return i.complete && i.naturalWidth > 0; }); }
    function end(play){ if (done) return; done = true; pb.classList.remove('arm'); if (play) pb.classList.add('go'); }
    pb.classList.add('arm');
    var pre = new IntersectionObserver(function(es){
      if (!es.some(function(e){ return e.isIntersecting; })) return;
      pre.disconnect();
      imgs.forEach(function(i){ i.loading = 'eager'; if (i.decode) i.decode().catch(function(){}); });
    }, {rootMargin: '0px 0px 100% 0px'});
    var io = new IntersectionObserver(function(es){
      if (!es.some(function(e){ return e.isIntersecting; })) return;
      io.disconnect();
      Promise.all(imgs.map(function(i){ return i.decode ? i.decode().catch(function(){}) : 0; })).then(function(){ end(ready()); });
      setTimeout(function(){ end(ready()); }, 1200);
    }, {rootMargin: '0px 0px -20% 0px'});
    pre.observe(pb); io.observe(pb);
  });
})();


/* Encart Miami : « Miami » s'allume et les stickers se posent à l'arrivée ; compte à rebours et libellés (heure de Paris) ;
   retrait après le 30/11. Mouvement réduit respecté. */
(function(){
  var me = document.querySelector('[data-me]'); if (!me) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var START = Date.parse('2026-11-02T11:30:00+01:00'), END = Date.parse('2026-11-30T23:59:59+01:00');
  var k = me.querySelector('[data-me-k]'), ck = me.querySelector('[data-me-ck]'), cnt = me.querySelector('[data-me-count]'), U = {};
  if (cnt) cnt.querySelectorAll('[data-u]').forEach(function(u){ U[u.getAttribute('data-u')] = u; });
  var two = function(n){ return (n < 10 ? '0' : '') + n; };
  var tick = function(){
    var now = Date.now();
    if (now > END){ me.hidden = true; return; }
    var pre = now < START, s = Math.floor(((pre ? START : END) - now) / 1000);
    if (k) k.textContent = pre ? '[\xa0Édition limitée · dès lundi 2 novembre\xa0]' : "[\xa0Édition limitée · jusqu'au 30 novembre\xa0]";
    if (ck) ck.textContent = pre ? '[\xa0Début du jeu dans\xa0]' : '[\xa0Fin du jeu dans\xa0]';
    if (U.d) U.d.textContent = Math.floor(s / 86400);
    if (U.h) U.h.textContent = two(Math.floor(s % 86400 / 3600));
    if (U.m) U.m.textContent = two(Math.floor(s % 3600 / 60));
  };
  tick(); setInterval(tick, 30000);
  if (!reduce && 'IntersectionObserver' in window){
    me.classList.add('is-armed');
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ me.classList.add('is-in'); io.disconnect(); } }); }, {threshold: .3});
    io.observe(me);
  }
})();


/* Bannière Team Pink / Team Blue (jeu Miami, du 2 au 30/11/2026) : compteur réel, votes anonymes, un par appareil.
   Aucun faux vote : 50/50 tant qu'il n'y a pas de vote ; le nombre de votes s'affiche à partir de 100.
   Lecture au chargement, après un vote, puis toutes les 30 s quand la bannière est à l'écran. */
(function(){
  var root = document.getElementById('team-miami'); if (!root || !window.fetch) return;
  var API = 'https://woodys-team-miami-986ddeaa.base44.app/functions', KEY = 'wf_miami_team', DEV = 'wf_miami_device', MIN = 100, NB = ' ';
  var fr = new Intl.NumberFormat('fr-FR'), mine = null, busy = false, last = null, seen = false;
  try { mine = localStorage.getItem(KEY); } catch (e) {}
  if (mine !== 'pink' && mine !== 'blue') mine = null;
  var btns = [].slice.call(root.querySelectorAll('.tm-vote')), bar = root.querySelector('[data-tm-bar]');
  var pr = root.querySelector('[data-tm-pr]'), pb = root.querySelector('[data-tm-pb]'), tot = root.querySelector('[data-tm-tot]'), msg = root.querySelector('[data-tm-msg]');
  function device(){
    var id = null; try { id = localStorage.getItem(DEV); } catch (e) {}
    if (!id) {
      id = (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2)).slice(0, 64);
      try { localStorage.setItem(DEV, id); } catch (e) {}
    }
    return id;
  }
  function draw(d){
    if (d) last = d;
    var p = last && last.pink || 0, b = last && last.blue || 0, t = p + b, r = t ? Math.round(p * 100 / t) : 50, q = 100 - r;
    pr.textContent = 'Team Pink ' + r + NB + '%'; pb.textContent = q + NB + '% Team Blue';
    bar.children[0].style.width = r + '%'; bar.children[1].style.width = q + '%';
    bar.setAttribute('aria-label', 'Répartition des votes : ' + r + ' % Team Pink, ' + q + ' % Team Blue');
    tot.textContent = t >= MIN ? fr.format(t) + ' votes · en direct' : 'Votes en direct';
    btns.forEach(function(x){
      var team = x.getAttribute('data-team'), on = mine === team;
      x.setAttribute('aria-pressed', on ? 'true' : 'false'); x.disabled = !!mine || busy;
      x.textContent = (team === 'pink' ? 'Team Pink' : 'Team Blue') + (on ? ' · votre vote' : '');
    });
  }
  function load(){
    fetch(API + '/tally', {cache: 'no-store'}).then(function(r){ if (!r.ok) throw r.status; return r.json(); }).then(draw).catch(function(){});
  }
  btns.forEach(function(x){
    x.addEventListener('click', function(){
      if (mine || busy) return;
      var team = x.getAttribute('data-team'); busy = true; draw();
      fetch(API + '/vote', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({team: team, device: device()})})
        .then(function(r){ if (!r.ok) throw r.status; return r.json(); })
        .then(function(d){
          mine = d.team === 'pink' || d.team === 'blue' ? d.team : team; busy = false;
          try { localStorage.setItem(KEY, mine); } catch (e) {}
          msg.textContent = d.already_voted ? 'Vous aviez déjà voté depuis cet appareil.' : (mine === 'pink' ? 'Merci, vous êtes Team Pink.' : 'Merci, vous êtes Team Blue.');
          msg.hidden = false; draw(d);
        })
        .catch(function(){ busy = false; msg.textContent = 'Votre vote n’est pas passé. Réessayez dans un instant.'; msg.hidden = false; draw(); });
    });
  });
  draw();
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(es){ seen = es[0].isIntersecting; if (seen) load(); }, {rootMargin: '200px 0px'}).observe(root);
  } else { seen = true; load(); }
  setInterval(function(){ if (seen && !document.hidden) load(); }, 30000);
})();
